<script>
  import Constantes from "../../Classes/Constantes";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import{ DadosLogin } from "../../Classes/Stores";
export let id_usuario=$DadosLogin.id_usuario;
export let id_assessoria;
  const conexao = new Conexoes();
  let isLoading = false;
  let message;
  let tempoTeste = "";
  let distancia = 3; // Distância padrão em km
  let paces = {};

  function calcularPaces() {
    let [minutos, segundos] = tempoTeste.split(":").map(Number);
    let tempoHoras = minutos / 60 + segundos / 3600;

    // Calcula a velocidade com base na distância escolhida
    let velocidade = distancia / tempoHoras;

    // Função para converter pace de min/km para min:seg
    function converterPace(pace) {
      let partes = pace.toFixed(2).split("."); // Divide o pace em minutos e segundos decimais
      let minutos = Math.floor(partes[0]); // Parte inteira representa minutos
      let segundosDecimais = partes[1] ? parseFloat("0." + partes[1]) * 60 : 0; // Parte decimal para segundos
      let segundos = Math.round(segundosDecimais); // Arredonda para o inteiro mais próximo

      // Ajusta minutos e segundos se segundos forem 60 ou mais
      if (segundos === 60) {
        minutos += 1;
        segundos = 0;
      }

      return `${minutos}:${segundos.toString().padStart(2, "0")}`;
    }

    // Calcula os intervalos de pace para cada zona
    function calcularIntervalo(minPct, maxPct) {
      let minPace = 60 / (velocidade * maxPct); // Pace mínimo (velocidade máxima)
      let maxPace = 60 / (velocidade * minPct); // Pace máximo (velocidade mínima)
      return `${converterPace(maxPace)} a ${converterPace(minPace)}`;
    }

    paces = {
      fácil: calcularIntervalo(0.65, 0.75),
      maratona: calcularIntervalo(0.8, 0.9),
      limite: calcularIntervalo(0.9, 0.95),
      intervalo: calcularIntervalo(0.95, 1.05),
      repetição: calcularIntervalo(1.05, 1.2),
    };
  }

  async function InserirPace() {
    isLoading = true;
    let result = await conexao.conecta(Constantes.api_insere_edita_metas_zonas, {
      pace_z1: paces.fácil,
      pace_z2: paces.maratona,
      pace_z3: paces.limite,
      pace_z4: paces.intervalo,
      pace_z5: paces.repetição,
      ativado:"1",
      id_assessoria:id_assessoria,
      id_usuario:id_usuario

    });

    if (result && result.sucesso){
      message=Constantes.msg_inserido_sucesso;
    }else{
      message=Constantes.msg_erro_conexao_bd;
    }
    isLoading=false;
  }
</script>
<LoadingTela {isLoading} />
<CaixaDeDialogo {message} on:close={()=>message=""}/>
<div class="container">
  <h3 class="text-center m-4">Calculadora de Zonas de Treinamento</h3>

  <div class="card p-4 shadow-sm">
    <div class="mb-3">
      <label for="tempoTeste" class="form-label">Tempo do Teste (mm:ss):</label>
      <input
        id="tempoTeste"
        type="time"
        bind:value={tempoTeste}
        class="form-control"
        placeholder="Ex: 12:30"
      />
    </div>

    <div class="mb-3">
      <label for="distancia" class="form-label">Distância do Teste (km):</label>
      <input
        id="distancia"
        type="number"
        bind:value={distancia}
        class="form-control"
        min="1"
        placeholder="Ex: 3"
      />
    </div>

    <button on:click={calcularPaces} class="btn btn-secondary w-100"
      >Calcular</button
    >
  </div>

  {#if Object.keys(paces).length > 0}
    <div class="resultado mt-4">
      <div class="card p-4 shadow-sm">
        <h2 class="card-title text-center mb-4">Paces Sugeridos:</h2>
        <ul class="list-group">
          <li class="list-group-item">
            Z1: <strong>{paces.fácil}</strong> min/km
          </li>
          <li class="list-group-item">
            Z2: <strong>{paces.maratona}</strong> min/km
          </li>
          <li class="list-group-item">
            Z3: <strong>{paces.limite}</strong> min/km
          </li>
          <li class="list-group-item">
            Z4: <strong>{paces.intervalo}</strong> min/km
          </li>
          <li class="list-group-item">
            Z5: <strong>{paces.repetição}</strong> min/km
          </li>
        </ul>
      </div>
    </div>
  {/if}
  {#if  id_usuario && id_usuario>0 && paces.maratona}
  <button  class="btn btn-primary w-100" on:click={InserirPace}>Salvar zonas</button>
  {/if}
  <!-- Alerta para metodologia -->
  <div class="alert alert-info mt-4" role="alert">
    <strong>Nota 1:</strong> Esta calculadora é inspirada nas fórmulas de Jack
    Daniels para estimar os paces de treino. No entanto, os resultados
    fornecidos são aproximados e não seguem exatamente as fórmulas originais.
    Eles devem ser usados apenas como uma estimativa geral e não como diretrizes
    definitivas. Recomendamos sempre consultar um profissional de saúde para
    ajustes personalizados e prescrição de treinos adequados. Para mais
    detalhes, consulte a obra: <em>Daniels' Running Formula</em>, 3ª edição, de
    Jack Daniels, PhD.
  </div>

  <!-- Rodapé explicando os avisos -->
  <div class="alert alert-info mt-4" role="alert">
    <p>
      <strong>Nota 2:</strong> Os resultados apresentados não devem ser seguidos
      rigidamente. Um profissional de saúde é necessário para fazer ajustes e prescrever
      treinos adequados. Além disso, é importante consultar um médico regularmente
      para acompanhamento.
    </p>
  </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />

<style>
  .container {
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
  }
  .resultado {
    margin-top: 20px;
  }
  footer {
    margin-top: 40px;
    font-size: 0.9rem;
    color: #555;
  }
</style>
